import { GET_USER_DATA } from '../actions/authActions';

const defaultState = false;

export const currentUser = (state = defaultState, action) => {
	switch (action.type) {
	case GET_USER_DATA:
		return action.user;

	default:
		return state;
	}
};

export const userData = (state = {}, action) => {
	return state;
};



// WEBPACK FOOTER //
// ./src/reducers/getUserData.js